import React, { createContext, useContext, useReducer } from "react";
import {timeStr} from './utils'

const StoreContext = createContext();

var date_to = new Date();

// add a day
date_to.setDate(date_to.getDate() + 1);

const initialState = {
    login:{
        name:"",
        idno:"",
        phone:"",
        birthday:"",
        patientIdno:"",
        imgSrc:""
    },
    page1:{
        gerneralInfo:{
            reg_date: timeStr(new Date()),
            apply_user_idno:"",
            apply_user_name:"",
            apply_user_mail:"",
            apply_user_phone:"",
            apply_user_birthday:"",       
            idno: "",     
            auth_code: "",                        
            reason:"",
            isPass:"N",
            remark:""
            // dept:""
        }
    },
    page2:{
        travelHistory:{
            isSelfGoAbroad:"",
            isFriendGoAbroad:"",
            isFamilyGoAbroad:"",
            countrySelf:"",
            countryFriend:"",
            countryFamily:"",
            selfDateOfEntry:"",
            isSelfQuarantineIso:""
        },
        occupation:{
            occupation:"",
            // others_text:"",
        },
        contactHistory:{
            HC:false,
            ATF:false,
            PA:false,
            RPEC:false,
            GMS:false,
            WB:false,
            others:false,
            none:false,
            // others_text:"",
        },
        cluster:{
            confirmCaseTouch:"",
            familyQuarantineIso:"",
            familyQuarantineCheck:"",
            familyHealthManage:"",
            dueDate:"",
            familySymptom:"",
            friendSymptom:"",
            colleagueSymptom:"",
            rfFrequentSymptom:""
        },
        healthHistory:{
            selfSymptom:"",
            selfPrevention:"",
            selfPreventionDate:null 
        }
    }    
};

const reducer = (state, action) => {
    switch (action.type){
        case 'SET_LOGIN':
            return {
                ...state,
                login: action.payload
            }

        case 'SET_GENERALINFO':
            return {
                ...state,
                page1:{
                    ...state.page1,
                    gerneralInfo: action.payload
                }
            }
        case 'SET_TRAVELHISTORY':
            return {
                ...state,
                page2:{
                    ...state.page2,
                    travelHistory: action.payload
                }
            }
        case 'SET_OCCUPATION':
            return {
                ...state,
                page2:{
                    ...state.page2,
                    occupation: action.payload
                }
            }
        case 'SET_CONTACTHISTORY':
            return {
                ...state,
                page2:{
                    ...state.page2,
                    contactHistory: action.payload
                }
            }
        case 'SET_CLUSTER':
            return {
                ...state,
                page2:{
                    ...state.page2,
                    cluster: action.payload
                }
            }
        case 'SET_HEALTHHISTORY':
            return {
                ...state,
                page2:{
                    ...state.page2,
                    healthHistory: action.payload
                }
            }

        default:
            return state;
    }
}

export const StoreProvider = ({ children }) => {    
    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <StoreContext.Provider value={[ state, dispatch ]}>
            {children}
        </StoreContext.Provider>
    );
};
  
 const useStore = () => {
    const [state, dispatch] = useContext(StoreContext);

    const setLogin = (payload) =>{
        dispatch({type:"SET_LOGIN" , payload:payload})
    }

    const setGeneralInfo = (payload) =>{
        dispatch({type:"SET_GENERALINFO" , payload:payload})
    }
      
    const setTravelHistory = (payload) =>{
        dispatch({type:"SET_TRAVELHISTORY", payload:payload})
    }

    const setOccupation = (payload) =>{
        dispatch({type:"SET_OCCUPATION", payload:payload})
    }

    const setContactHistory = (payload) =>{
        dispatch({type:"SET_CONTACTHISTORY", payload:payload})
    } 

    const setCluster = (payload) =>{
        dispatch({type:"SET_CLUSTER", payload:payload})
    } 

    const setHealthHistory = (payload) =>{
        dispatch({type:"SET_HEALTHHISTORY", payload:payload})
    } 

    return {
        setLogin,
        login:{
            ...state.login
        },
        setGeneralInfo,
        gerneralInfo:{
            ...state.page1.gerneralInfo
        },
        setTravelHistory,
        travelHistory:{
            ...state.page2.travelHistory
        },
        setOccupation,
        occupation:{
            ...state.page2.occupation
        },
        setContactHistory,
        contactHistory:{
            ...state.page2.contactHistory
        },
        setCluster,
        cluster:{
            ...state.page2.cluster
        },
        setHealthHistory,
        healthHistory:{
            ...state.page2.healthHistory
        }
    }
};

export default useStore
  
  